export enum UserType {
  // This flag can be used to provide different user experience for different user types
  TythonSelfServe = 1,
}
